import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DateRangePicker } from 'rsuite'
import moment from 'moment'

import { setDateRangeControlPanel } from '../../../../store/actions/controlPanel'
import {
  getLast30DaysFromToday,
  getTodayDate,
  getLast30DaysFromTodayObj,
  getLast15DaysFromTodayObj,
  getLast7DaysFromTodayObj,
  getTodayDateObj,
} from '../../../../utils/dates'
import 'rsuite/dist/styles/rsuite-default.css'

const { allowedRange } = DateRangePicker

export default function DatePickers() {
  const dateRangeFromRedux = useSelector(
    (state) => state.controlPanel.dateRange
  )
  const [dateRange, setDateRange] = useState([])
  const dispatch = useDispatch()
  const allowedRangeConfig = allowedRange(
    getLast30DaysFromTodayObj(),
    getTodayDateObj()
  )
  const datePickerRanges = [
    {
      label: 'Last 7 Days',
      value: [getLast7DaysFromTodayObj(), getTodayDateObj()],
    },
    {
      label: 'Last 15 Days',
      value: [getLast15DaysFromTodayObj(), getTodayDateObj()],
    },
    {
      label: 'Last 30 Days',
      value: [getLast30DaysFromTodayObj(), getTodayDateObj()],
    },
  ]

  useEffect(() => {
    setDefaultRanges()
  }, [])

  useEffect(() => {
    setDateRange([
      moment(dateRangeFromRedux[0]).toDate(),
      moment(dateRangeFromRedux[1]).toDate(),
    ])
  }, [dateRangeFromRedux])

  const handleChange = (event) => {
    const range = []
    event.forEach((item) => {
      range.push(moment(item).format('YYYY-MM-DD'))
    })
    dispatch(setDateRangeControlPanel(range))
  }

  const setDefaultRanges = () => {
    const rangeWithFormat = [
      getLast30DaysFromToday(),
      getTodayDate('YYYY-MM-DD'),
    ]
    dispatch(setDateRangeControlPanel(rangeWithFormat))
  }

  const handleClean = () => {
    setDefaultRanges()
  }

  return (
    <DateRangePicker
      value={dateRange}
      appearance="default"
      disabledDate={allowedRangeConfig}
      onClean={handleClean}
      onChange={handleChange}
      ranges={datePickerRanges}
    />
  )
}
